import React from "react";

import { Button } from "@/components/ui/button";
import Typography from "@/components/Typography/Typography";
import CustomIconifyIcon from "@/components/CustomIconifyIcon/CustomIconifyIcon";

import { IAccordionProps } from "@/interfaces/AccordionButton/AccordionButton";

export default function AccordionButton({
  expanded,
  setExpanded,
  value,
  className,
}: IAccordionProps) {
  return (
    <Button
      className={`py-4 px-6 h-3.25 whitespace-nowrap text-colorSecondary-900 bg-white group hover:bg-colorSecondary-50 border rounded-full hover:border-colorSecondary space-x-10  border-colorSecondary-900 hover:text-colorSecondary-900 ease-out duration-300 ${className}`}
      onClick={() => setExpanded((prev: boolean) => !prev)}
    >
      <Typography
        variant="button-label"
        className="text-colorSecondary-900 !text-0.8125 font-extrabold ease-out duration-300"
      >
        {value}
      </Typography>
      <CustomIconifyIcon
        name={"formkit:down"}
        className={`${expanded ? "rotate-180" : "rotate-0"} w-1.063 h-10 ease-out duration-300
          `}
      />
    </Button>
  );
}
